import { render, staticRenderFns } from "./ModalPatternCustomizer.vue?vue&type=template&id=fc3b501c&scoped=true&"
import script from "./ModalPatternCustomizer.vue?vue&type=script&lang=js&"
export * from "./ModalPatternCustomizer.vue?vue&type=script&lang=js&"
import style0 from "./ModalPatternCustomizer.vue?vue&type=style&index=0&id=fc3b501c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc3b501c",
  null
  
)

export default component.exports